import { useState, useCallback } from 'react';
import axios from 'common/AxiosAuth';

interface TLEData {
  tleTitle: string;
  tleFirst: string;
  tleSecond: string;
}
const API_KEY = process.env.REACT_APP_N2YO_API_KEY;

export const useTLEData = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [tleData, setTLEData] = useState<TLEData | null>(null);

  const fetchTLEData = useCallback(async (noradId: string) => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await axios.get(`/rest/${noradId}`, {
        params: { apiKey: API_KEY }
      });
      const data = res.data;
      if (data && data.info && data.tle) {
        setTLEData({
          tleTitle: data.info.satname,
          tleFirst: data.tle.split('\n')[0],
          tleSecond: data.tle.split('\n')[1]
        });
      } else {
        throw new Error('Invalid TLE data structure');
      }
    } catch (error) {
      console.error('Error fetching TLE data:', error);
      setError(`Failed to fetch TLE data for NORAD ID ${noradId}. Please check the ID and try again.`);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { isLoading, error, tleData, fetchTLEData };
};